var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import authentication from "@irati/auth";
import getDeviceLocale from "@irati/utils/lang/helpers/getDeviceLocale";
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname";
import intercomScript, { getIntercomKey } from "./script";
import BaseIntercom from "./base";
import domain from "../env/domain";
var Intercom = /** @class */ (function (_super) {
    __extends(Intercom, _super);
    function Intercom() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Intercom.prototype.setup = function () {
        var shouldLoad = domain.isTenant() || domain.isGlobal() || domain.isMerchant() || domain.isSandbox();
        if (shouldLoad) {
            intercomScript(getIntercomKey());
        }
    };
    Intercom.prototype.setIdentity = function (user, business) {
        return __awaiter(this, void 0, void 0, function () {
            var versionData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!window.Intercom) {
                            return [2 /*return*/, notLoaded()];
                        }
                        return [4 /*yield*/, this.getClientVersion()];
                    case 1:
                        versionData = _a.sent();
                        window.Intercom("shutdown");
                        return [2 /*return*/, window.Intercom("boot", __assign(__assign(__assign({}, defaultIntercomSettings()), identityData(user, business)), versionData))];
                }
            });
        });
    };
    Intercom.prototype.updateIdentity = function (user, business) {
        return __awaiter(this, void 0, void 0, function () {
            var versionData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!window.Intercom) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getClientVersion()];
                    case 1:
                        versionData = _a.sent();
                        window.Intercom("update", __assign(__assign({}, identityData(user, business)), versionData));
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    Intercom.prototype.clearIdentity = function () {
        if (window.Intercom) {
            window.Intercom("shutdown");
            window.Intercom("boot", __assign({}, defaultIntercomSettings()));
        }
    };
    Intercom.prototype.hide = function () {
        if (window.Intercom) {
            window.Intercom("update", {
                hide_default_launcher: true
            });
        }
    };
    Intercom.prototype.show = function () {
        if (window.Intercom) {
            window.Intercom("update", {
                hide_default_launcher: false
            });
        }
    };
    Intercom.prototype.logEvent = function (eventName, data) {
        if (!window.Intercom) {
            return notLoaded();
        }
        return window.Intercom("trackEvent", eventName, data);
    };
    Intercom.prototype.addCustomMessage = function (message, url) {
        if (window.Intercom) {
            window.Intercom("showNewMessage", message);
            if (url) {
                window.Intercom("update", { Url: url });
            }
        }
    };
    return Intercom;
}(BaseIntercom));
export default new Intercom();
var thrown = false;
function notLoaded() {
    if (!thrown) {
        // only throw once
        thrown = true;
        // As 3rd party script, cannot always guarantee it will load
        console.error("Intercom failed to load");
    }
    return thrown;
}
function defaultIntercomSettings() {
    return {
        app_id: getIntercomKey(),
        region: authentication.userLocale(),
        device_locale: getDeviceLocale(),
        language_override: authentication.userLocale()
    };
}
function identityData(user, business) {
    var role = user.role;
    return {
        user_id: user.uuid,
        email: user.email,
        name: firstnameLastname(user),
        role: role,
        company: {
            company_id: business.subdomain,
            name: business.businessName,
            tenant_group_id: business.groupId,
            user_locale: user.locale,
            tenant_uuid: business.uuid
        }
    };
}
